<template>
    <div>
        <h2>
            Invoices
            <small>You have {{ total }} invoices available.</small>
        </h2>

        <div class="white" v-if="loading || total > 0">
            <div class="content">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Reference</th>
                            <th class="center">Payment Date</th>
                            <th class="center">Amount</th>
                            <th class="center">Status</th>
                            <th class="center">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td>{{ invoice.reference }}</td>
                            <td class="center">
                                <span class="tooltip tooltip-left" :data-tooltip="invoice.created|datetime">{{ invoice.created|relative|capitalize }}</span>
                            </td>
                            <td class="center">{{ invoice.amount|floating }}</td>
                            <td class="center">
                                <template v-if="invoice.amount < 0">Refunded</template>
                                <template v-else>Paid</template>
                            </td>
                            <td class="center">
                                <a :href="invoice.download_url" target="_blank" class="btn btn-light">Download</a>
                            </td>
                        </tr>
                        <tr v-if="hasMore">
                            <td colspan="5" class="text-center">
                                <a href="javascript:;" title="Load the next invoices" @click="loadNext()">Load the next invoices</a>
                            </td>
                        </tr>
                        <tr v-if="loading" class="loading">
                            <td colspan="5" class="text-center">
                                <svg-loader />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="alert alert-success" v-else>
            You currently don't have any invoices.<br />
            If you absolutely want one, you can <router-link :to="{ name: 'upgrade' }" title="Click here to upgrade your account">upgrade</router-link> 😉
        </div>
    </div>
</template>

<script>
import SvgLoader from '@/assets/images/loader.svg'

export default {
    components: { SvgLoader },
    data () {
        return {
            invoices: null,
            total: null,
            page: 0,
            hasMore: false,
            loading: true
        }
    },
    created () {
        this.loadInvoices()
    },
    methods: {
        loadInvoices () {
            if (this.page === 0) {
                this.invoices = []
            }

            this.loading = true
            this.$http.get('invoices/', { params: { page: this.page } }).then(response => {
                this.invoices = this.invoices.concat(response.body.invoices.data)
                this.total = response.body.invoices.total
                this.hasMore = response.body.invoices.has_more
                this.loading = false
            })
        },
        loadNext () {
            this.hasMore = false
            this.page += 1
            this.loadInvoices()
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../public/css/vars';

    .tooltip {
        border-bottom: dotted 1px #000;
    }

    .content {
        border-radius: 8px;
        overflow-y: auto; /* keeps the scrollbar even if it doesn't need it; display purpose */
        min-height: 250px;
        max-height: calc(100vh - 300px);

        th {
            position: sticky;
            top: 0;
            z-index: 500;
        }
    }

    .loading svg {
        height: 24px;
        fill: fade-out($menu-active-color, .2)
    }

    .success {
        font-style: normal;
        text-align: center;
    }
</style>
